module.exports = __webpack_public_path__ + "media/images/country_flags/tl-835a669413606914b9a6013be65f7918.png";